import React, { Component, useRef } from 'react';
import * as FeatherIcon from 'react-feather';
import { useSpring, animated } from 'react-spring';
import logo from 'images/logoNoBackground.png';
import botLogo from 'images/chatLogo.png';
import chatLogo from 'images/KK_image.jpg';
import './index.css';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { getChatBotResponse } from '../../../service/infinitetableproperties/action';

const Footer = () => {
    const messagesEndRef = useRef(null);

    const [showChat, setShowChat] = React.useState(false);
    const [qus, setQus] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [chatType, setChatType] = React.useState('');
    const defaultMessage = [
        { message: 'Hello User!!', isUser: false },
        { message: 'Hi There!!', isUser: true },
    ];
    const [messages, setMessages] = React.useState([]);
    const chatTypes = (type) => {
        setChatType(type);
        const msg = {
            message: type === 'BlocData' ? 'How may I help you?' : 'Please enter your issue description',
            isUser: false,
        };
        // messages.push(msg);
        setMessages([msg]);
    };
    const chatSpring = useSpring({
        transform: showChat ? 'translateX(0%)' : 'translateX(101%)',
    });

    const toggleChat = () => {
        setQus('');
        setShowChat(!showChat);
        setMessages([]);
        let radio = document.getElementsByName('chatType');
        radio.forEach((itm) => (itm.checked = false));
    };
    const sendChat = async () => {
        const request = { message: qus, isUser: true };
        messages.push(request);
        const { data } = await getChatBotResponse(qus);
        const { answer } = data.data;
        const response = { message: answer, isUser: false };
        messages.push(response);
        setMessages(messages);
        setQus('');
        setLoading(false);
    };

    React.useEffect(() => {
        if (messagesEndRef) {
            messagesEndRef.current.addEventListener('DOMNodeInserted', (event) => {
                const { currentTarget: target } = event;
                target.scroll({ top: target.scrollHeight, behavior: 'smooth' });
            });
        }
    }, [messages]);

    return (
        <footer className="footer">
            <div className="container-fluid">
                <div className="row">
                    <div>
                        <div class="div-img">
                            {/* <FeatherIcon.MessageCircle fill='#4BB3BC'  /> */}
                            <img onClick={toggleChat} className="enlarge" src={botLogo} />
                        </div>
                        {/* <button style={{ borderRadius: 30 }} >
                        </button> */}
                        <animated.div className="chat-container mb-1 mr-1" style={chatSpring}>
                            {/* Chat content goes here */}
                            <div className="chat-header">
                                <div className="d-flex w-100">
                                    <Label>Vincilium</Label>
                                    <FeatherIcon.X
                                        style={{ cursor: 'pointer' }}
                                        className="mt-2 icon-xs ml-auto"
                                        onClick={() => toggleChat()}
                                    />
                                </div>
                            </div>
                            <div
                                className="chat-body"
                                ref={messagesEndRef}
                                style={{ height: '75%', overflowX: 'hidden', overflowY: 'auto' }}
                            >
                                {defaultMessage.map((item, idx) => (
                                    <>
                                        <div className={item.isUser ? 'float-right font-weight-bold' : 'float-left w-100'} key={idx}>
                                            {!item.isUser && <img src={chatLogo} height={15} className="mr-2 mb-1" alt="" />}
                                            {item.message}
                                        </div>
                                        <br />
                                    </>
                                ))}
                                <FormGroup className="d-flex w-100 m-2">
                                    <div className="mx-3 w-100" style={{ position: 'sticky' }}>
                                        <Input className="mt-2" name="chatType" onClick={() => chatTypes('BlocData')} type="radio" />
                                        <Label>Bloc Data</Label>
                                    </div>
                                    <div className="mx-3 w-100" style={{ position: 'sticky' }}>
                                        <Input className="mt-2" name="chatType" onClick={() => chatTypes('RaiseTicket')} type="radio" />
                                        <Label>Raise Ticket</Label>
                                    </div>
                                </FormGroup>
                                {messages.map((data, index) => (
                                    <>
                                        <div
                                            className={data.isUser ? 'float-right my-1 font-weight-bold' : 'float-left w-100 my-1'}
                                            key={index}
                                        >
                                            {!data.isUser && <img src={chatLogo} height={15} className="mr-2 mb-1" alt="" />}
                                            {data.message}
                                        </div>
                                        <br />
                                    </>
                                ))}
                            </div>
                            <Form>
                                <div className="w-100" style={{ position: 'absolute', bottom: 2, left: 2 }}>
                                    {loading && (
                                        <div class="typing mb-3 ml-2">
                                            <span className="typingDot"></span>
                                            <span className="typingDot"></span>
                                            <span className="typingDot"></span>
                                        </div>
                                    )}
                                    <div className="d-flex w-100">
                                        <Input
                                            placeholder="How can I help you ?"
                                            value={qus}
                                            type="text"
                                            onChange={({ target: { value } }) => setQus(value)}
                                        />
                                        <button
                                            type="submit"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setLoading(true);
                                                sendChat();
                                            }}
                                        >
                                            <FeatherIcon.Send className="icon-dual icon-md m-1" />
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </animated.div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
